var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductPedigree({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 88 88",
    style: {
      enableBackground: "new 0 0 88 88"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#C29E51;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.1,67.7l6.1,6.1H25.5c-1.7,0-3.1-0.6-4.3-1.8c-1.2-1.2-1.8-2.6-1.8-4.3V19.1c0-1.7,0.6-3.1,1.8-4.3 c1.2-1.2,2.6-1.8,4.3-1.8h27.3L68,31.2v36.5c0,1-0.2,1.9-0.6,2.8s-1,1.5-1.8,2.1L49.8,56.9c-0.9,0.6-1.8,1-2.8,1.3 c-1,0.3-2.1,0.4-3.3,0.4c-3.3,0-6.2-1.2-8.6-3.6s-3.6-5.2-3.6-8.6s1.2-6.2,3.6-8.6c2.4-2.4,5.2-3.6,8.6-3.6s6.2,1.2,8.6,3.6 c2.4,2.4,3.6,5.2,3.6,8.6c0,1.2-0.1,2.3-0.4,3.3c-0.3,1-0.7,1.9-1.3,2.8l7.7,7.9v-27l-12-14.3H25.5v48.6H52.1z M43.7,52.5 c1.7,0,3.1-0.6,4.3-1.8c1.2-1.2,1.8-2.6,1.8-4.3s-0.6-3.1-1.8-4.3s-2.6-1.8-4.3-1.8s-3.1,0.6-4.3,1.8c-1.2,1.2-1.8,2.6-1.8,4.3 s0.6,3.1,1.8,4.3C40.6,51.9,42,52.5,43.7,52.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductPedigree);
export default __webpack_public_path__ + "static/media/product-pedigree.87535e00215d3d96e872a16e483b7362.svg";
export { ForwardRef as ReactComponent };